module.exports = __webpack_public_path__ + "img/gmapMarker_Axerta.a0dbff81.svg";